import * as Yup from "yup";

const itemParametroPrecificacaoValidator = Yup.object().shape({
  compra: Yup.array().of(
    Yup.object().shape({
      descricao: Yup.string().required("Descricao"),
      referencia: Yup.string().nullable(),
      expressao: Yup.string()
        .required("Expressão")
        .when("calculoSemParametro", {
          is: false,
          then: (schema) =>
            schema.test(
              "contém-parametro",
              'A string deve conter a palavra "Parâmetro"',
              (value) => (value ? value.includes("Parâmetro") : false)
            ),
          otherwise: (schema) => schema,
        }),
      calculoSemParametro: Yup.boolean().nullable(),
    })
  ),
  venda: Yup.array().of(
    Yup.object().shape({
      descricao: Yup.string().required("Descricao"),
      referencia: Yup.string().nullable(),
    })
  ),
});

export default itemParametroPrecificacaoValidator;
